import type { VerbTypes } from 'modules/core/lib/verbTypes'

import Policy from './Policy'

class EnpsFormPolicy extends Policy<VerbTypes> {
  checkVerb(verb: VerbTypes): boolean {
    switch (verb) {
      case 'editEnpsForm':
        return this.permissions.edit

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
    }
  }
}

export default EnpsFormPolicy
